export const SET_USER_INFO = 'SET_USER_INFO'
export const SET_COMPANIES_LIST = 'SET_COMPANIES_LIST'
export const SET_ACTIVE_COMPANY = 'SET_ACTIVE_COMPANY'
export const SET_POSITIONS_LIST = 'SET_POSITIONS_LIST'
export const SET_BALANCE_INVOICE = 'SET_BALANCE_INVOICE'
export const SET_TAX_CREDIT_NOTE = 'SET_TAX_CREDIT_NOTE'
export const SET_USERS_LIST = 'SET_USERS_LIST'
export const SET_VENDOR_TAGS = 'SET_VENDOR_TAGS'
export const SET_FILTER_VENDOR_TAGS = 'SET_FILTER_VENDOR_TAGS'
export const SET_SEARCH_VENDOR = 'SET_SEARCH_VENDOR'
export const SET_TYPE_SEARCH_VENDOR_TAGS = 'SET_TYPE_SEARCH_VENDOR_TAGS'
export const SET_USERS_LIST_COLUMNS_DATA = 'SET_USERS_LIST_COLUMNS_DATA'
export const SET_BANK_DETAILS = 'SET_BANK_DETAILS'
export const SET_SERVICE_CATEGORIES = 'SET_SERVICE_CATEGORIES'
export const SET_SERVICE_INSTITUTIONS = 'SET_SERVICE_INSTITUTIONS'
export const SET_SERVICE_PROJECT = 'SET_SERVICE_PROJECT'
export const SET_SERVICES_LIST = 'SET_SERVICES_LIST'
export const SET_CONTACTS_LIST = 'SET_CONTACTS_LIST'
export const SET_CLIENT_INFO = 'SET_CLIENT_INFO'
export const SET_INFO_USER = 'SET_INFO_USER'
export const SET_INVOICES_LIST = 'SET_INVOICES_LIST'
export const SET_INVOICES_TOTAL = 'SET_INVOICES_TOTAL'
export const SET_SOA_LIST = 'SET_SOA_LIST'
export const SET_SOA_TOTALS = 'SET_SOA_TOTALS'
export const SET_SOA_LOADING_ZIP = 'SET_SOA_LOADING_ZIP'
export const SET_BALANCE_ACCOUNTS_COLUMNS_DATA = 'SET_BALANCE_ACCOUNTS_COLUMNS_DATA'
export const SET_BALANCE_ACCOUNTS_ROWS_DATA = 'SET_BALANCE_ACCOUNTS_ROWS_DATA'
export const SET_BALANCE_CLIENTS_COLUMNS_DATA = 'SET_BALANCE_CLIENTS_COLUMNS_DATA'
export const SET_BALANCE_CLIENTS_ROWS_DATA = 'SET_BALANCE_CLIENTS_ROWS_DATA'
export const SET_BALANCE_PARTNERS_COLUMNS_DATA = 'SET_BALANCE_PARTNERS_COLUMNS_DATA'
export const SET_BALANCE_PARTNERS_ROWS_DATA = 'SET_BALANCE_PARTNERS_ROWS_DATA'
export const SET_PAYROLL_COLUMNS_DATA = 'SET_PAYROLL_COLUMNS_DATA'
export const SET_PAYROLL_ROWS_DATA = 'SET_PAYROLL_ROWS_DATA'
export const SET_LIST_OF_PAYMENTS_COLUMNS_DATA = 'SET_LIST_OF_PAYMENTS_COLUMNS_DATA'
export const SET_LIST_OF_PAYMENTS_ROWS_DATA = 'SET_LIST_OF_PAYMENTS_ROWS_DATA'
export const SET_EXPENSES_CATEGORIES = 'SET_EXPENSES_CATEGORIES'
export const SET_EXPENSES_COLUMNS_DATA = 'SET_EXPENSES_COLUMNS_DATA'
export const SET_EXPENSES_ROWS_DATA = 'SET_EXPENSES_ROWS_DATA'
export const SET_CACHE_COLUMNS_DATA = 'SET_CACHE_COLUMNS_DATA'
export const SET_CACHE_ROWS_DATA = 'SET_CACHE_ROWS_DATA'
export const SET_FUNDS_COLUMNS_DATA = 'SET_FUNDS_COLUMNS_DATA'
export const SET_FUNDS_ROWS_DATA = 'SET_FUNDS_ROWS_DATA'
export const SET_FUNDS_TRANSFERS_COLUMNS_DATA = 'SET_FUNDS_TRANSFERS_COLUMNS_DATA'
export const SET_FUNDS_TRANSFERS_ROWS_DATA = 'SET_FUNDS_TRANSFERS_ROWS_DATA'
export const SET_KPI_COLUMNS_DATA = 'SET_KPI_COLUMNS_DATA'
export const SET_KPI_ROWS_DATA = 'SET_KPI_ROWS_DATA'
export const SET_KPI_EARNED_COLUMNS_DATA = 'SET_KPI_EARNED_COLUMNS_DATA'
export const SET_KPI_EARNED_ROWS_DATA = 'SET_KPI_EARNED_ROWS_DATA'
export const SET_DEPARTMENTS_LIST = 'SET_DEPARTMENTS_LIST'
export const SET_CREDIT_NOTES_COLUMNS_DATA = 'SET_CREDIT_NOTES_COLUMNS_DATA'
export const SET_CREDIT_NOTES_ROWS_DATA = 'SET_CREDIT_NOTES_ROWS_DATA'
export const SET_GAPI = 'SET_GAPI'
export const SET_MAIN_SCROLL = 'SET_MAIN_SCROLL'
export const SET_VAT_DOCS_COLUMNS_DATA = 'SET_VAT_DOCS_COLUMNS_DATA'
export const SET_VAT_DOCS_ROWS_DATA = 'SET_VAT_DOCS_ROWS_DATA'
export const SET_CONTACTS_PROJECTS_COLUMNS_DATA = 'SET_CONTACTS_PROJECTS_COLUMNS_DATA'
export const SET_CONTACTS_PROJECTS_COLUMNS_DATA_APPROVED = 'SET_CONTACTS_PROJECTS_COLUMNS_DATA_APPROVED'
export const SET_CONTACTS_PROJECTS_ROWS_DATA = 'SET_CONTACTS_PROJECTS_ROWS_DATA'
export const SET_CONTACTS_PROJECTS_ROWS_DATA_APPROVED = 'SET_CONTACTS_PROJECTS_ROWS_DATA_APPROVED'
export const SET_WRITE_OFF_COLUMNS_DATA = 'SET_WRITE_OFF_COLUMNS_DATA'
export const SET_WRITE_OFF_ROWS_DATA = 'SET_WRITE_OFF_ROWS_DATA'
export const SET_CONTACTS_FINANCES_COLUMNS_DATA = 'SET_CONTACTS_FINANCES_COLUMNS_DATA'
export const SET_CONTACTS_FINANCES_ROWS_DATA = 'SET_CONTACTS_FINANCES_ROWS_DATA'
export const SET_CONTACT_DOCS = 'SET_CONTACT_DOCS'
export const REMOVE_CONTACT_DOC = 'REMOVE_CONTACT_DOC'
export const UPDATE_CONTACT_DOC = 'UPDATE_CONTACT_DOC'
export const SET_CLIENT_COMPANIES = 'SET_CLIENT_COMPANIES'
export const SET_EMAIL_STORE = 'SET_EMAIL_STORE'
export const SET_SEND_EMAIL = 'SET_SEND_EMAIL'
export const SET_BB_CONFIG_API_KEYS = 'SET_BB_CONFIG_API_KEYS'
export const SET_LOGS_COLUMNS_DATA = 'SET_LOGS_COLUMNS_DATA'
export const SET_LOGS_ROWS_DATA = 'SET_LOGS_ROWS_DATA'
export const SET_COUNTRY_FLAGS = 'SET_COUNTRY_FLAGS'
export const SET_OPEN_NOTIFICATIONS = 'SET_OPEN_NOTIFICATIONS'
export const SET_NOTIFICATIONS_LIST = 'SET_NOTIFICATIONS_LIST'
export const SET_EMAIL_STATS_ROWS_DATA = 'SET_EMAIL_STATS_ROWS_DATA'
export const SET_WINDOW_AUTH_POPUP = 'SET_WINDOW_AUTH_POPUP'
export const SET_RAW_NOTIFICATIONS = 'SET_RAW_NOTIFICATIONS'
export const SET_SERVICE_PROVIDER_COLUMNS_DATA = 'SET_SERVICE_PROVIDER_COLUMNS_DATA'
export const SET_SERVICE_PROVIDER_ROWS_DATA = 'SET_SERVICE_PROVIDER_ROWS_DATA'
export const SET_CURRENT_COMPANY = 'SET_CURRENT_COMPANY'
export const SET_TIMER = 'SET_TIMER'
export const SET_START_TIMER = 'SET_START_TIMER'
export const SET_PAUSE_TIMER = 'SET_PAUSE_TIMER'
export const SET_SHOW_TIMER = 'SET_SHOW_TIMER'
export const SET_ACTIVE_TIMER = 'SET_ACTIVE_TIMER'
export const SET_SHOW_TIMER_MODAL = 'SET_SHOW_TIMER_MODAL'
export const SET_SHOW_TIMER_MODAL_FINANCE = 'SET_SHOW_TIMER_MODAL_FINANCE'
export const SET_TAGS = 'SET_TAGS'
export const SET_LIST_OF_REQUEST_TAGS = 'SET_LIST_OF_REQUEST_TAGS'
export const SET_CURRENT_DOMAIN = 'SET_CURRENT_DOMAIN'
export const SET_NEW_TECHNICAL_SUGGESTION = 'SET_NEW_TECHNICAL_SUGGESTION'
export const REMOVE_NEW_TECHNICAL_SUGGESTION = 'REMOVE_NEW_TECHNICAL_SUGGESTION'
export const SET_CARD_CREATED_HISTORY_ENTITY = 'SET_CARD_CREATED_HISTORY_ENTITY'



// WEBPACK FOOTER //
// ./src/constants/mutationTypes.js